import { render, staticRenderFns } from "./AdminBusiness.vue?vue&type=template&id=72a59dee&scoped=true&"
import script from "./AdminBusiness.vue?vue&type=script&lang=js&"
export * from "./AdminBusiness.vue?vue&type=script&lang=js&"
import style0 from "./AdminBusiness.vue?vue&type=style&index=0&id=72a59dee&lang=less&scoped=true&"
import style1 from "./AdminBusiness.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a59dee",
  null
  
)

export default component.exports